module.exports = __webpack_public_path__ + "static/media/gatsby-strapi.98d6d698.jpg";